import React from 'react';
import { Tables } from '../../../../../Components';
const ChangedFieldsTables = ({
  changedFields,
  parentTranslationPath,
  translationPath,
}) => {
  const arrayItemsHandler = (list) =>
    list
      .map(
        (item) =>
          item.lookupItemName ??
          item.name ??
          item.email_address?.email ??
          item.phone ??
          item.fullName ??
          item
      )
      .join(', ');
  const changedFieldDataHandler = (changedFields) => {
    if (!changedFields) return;
    if (['string', 'number'].includes(typeof changedFields)) {
      return changedFields;
    } else if (Array.isArray(changedFields)) {
      return arrayItemsHandler(changedFields);
    } else if (typeof changedFields === 'object') {
      return JSON.stringify(changedFields);
    }
  };
  return (
    <Tables
      data={changedFields}
      headerData={[
        {
          label: 'field_name',
          input: 'fieldName',
        },
        {
          label: 'changed_from',
          component: (el) => changedFieldDataHandler(el.changedFrom),
        },
        {
          label: 'changed_to',
          component: (el) => changedFieldDataHandler(el.changedTo),
        },
      ]}
      activePage={0}
      itemsPerPage={changedFields?.length}
      defaultActions={[]}
      translationPath={translationPath}
      parentTranslationPath={parentTranslationPath}
      totalItems={changedFields?.length}
      insideForm
    />
  );
};
export default ChangedFieldsTables;
